import {
  Box,
  Center,
  CircularProgress,
  CircularProgressLabel,
  Flex,
  Image,
  Text,
} from '@chakra-ui/react'
import GlobalMic3 from '@components/GlobalMic3'
import SnailIcon from '@assets/svgs/snail.svg'
import VolumeIcon from '@assets/svgs/learn/volume_2.svg'
import {useState} from 'react'
import {CommonColors} from '@utils/CommonStyles'
import {ReactComponent as ArrowRightIcon} from '@assets/svgs/learn/arrow_right_6.svg'
import GlobalButton from '@components/GlobalButton/GlobalButton'
import {useDispatch} from 'react-redux'
import appRequest from '@apis/app'
import {updateAudio} from '@redux/paraphrase/paraphraseSlice'

const sentence = 'The instructor clarified the challenging topic'
const audioUrl = 'https://smedia.stepup.edu.vn/ielts/audio/AC2_example_moi.wav'

const CheckPronunciation = ({setStep}: {setStep: (step: number) => void}) => {
  const [speechData, setSpeechData] = useState<any>()
  const [isLoading, setIsLoading] = useState(false)
  const [recordingCount, setRecordingCount] = useState(0)
  const [isRecording, setIsRecording] = useState(false)
  const dispatch = useDispatch()

  const getColorByScore = (score: any) => {
    if (score >= 75) return '#45BB66'
    if (score >= 50) return '#FFCD00'
    return '#E55856'
  }

  const handleRecordingComplete = async (blob: any) => {
    try {
      setIsLoading(true)
      setIsRecording(false)
      let file = new File([blob], 'audio.wav', {type: 'audio/wav'})
      const formData = new FormData()
      formData.append('audio-file', file)
      formData.append('text-refs', sentence)
      const res = await appRequest.getSpeechCheck(formData)
      setSpeechData(res?.data?.data)
      setRecordingCount(prev => prev + 1)
    } catch (error) {
    } finally {
      setIsLoading(false)
    }
  }

  const handlePlayAudio = (url: string, speed: number) => {
    const audioData = {
      time: Date.now(),
      url: url,
      speed: speed,
    }
    dispatch(updateAudio(audioData))
  }

  const handlePauseAudio = () => {
    const audioData = {
      time: Date.now(),
      url: '',
    }
    dispatch(updateAudio(audioData))
  }

  const handleStartRecording = () => {
    handlePauseAudio()
    setIsRecording(true)
  }

  return (
    <Flex flexDirection={'column'} alignItems={'center'} h={'100%'}>
      <Text fontSize={'18px'} color={CommonColors.primary}>
        HÃY PHÁT ÂM CÂU ĐÃ PARAPHRASE
      </Text>
      <CircularProgress
        mt={'40px'}
        value={Math.floor(speechData?.total_score * 100) || 0}
        color={getColorByScore(Math.floor(speechData?.total_score * 100))}
        size={'128px'}
        thickness="4px">
        <CircularProgressLabel
          fontSize={'64px'}
          fontWeight={600}
          color={
            speechData
              ? getColorByScore(Math.floor(speechData?.total_score * 100))
              : '#edebe9'
          }>
          {speechData ? Math.floor(speechData?.total_score * 100) : 0 || '--'}
        </CircularProgressLabel>
      </CircularProgress>
      <Flex mt={'32px'} gap={'12px'}>
        <Center
          cursor={isRecording ? 'not-allowed' : 'pointer'}
          h={'64px'}
          w={'96px'}
          borderRadius={'24px'}
          bg={'rgba(236, 239, 241, 0.50)'}
          opacity={isRecording ? 0.5 : 1}
          onClick={() => !isRecording && handlePlayAudio(audioUrl, 1)}>
          <Image src={VolumeIcon} />
        </Center>
        <Center
          cursor={isRecording ? 'not-allowed' : 'pointer'}
          h={'64px'}
          w={'96px'}
          borderRadius={'24px'}
          bg={'rgba(236, 239, 241, 0.50)'}
          opacity={isRecording ? 0.5 : 1}
          onClick={() => !isRecording && handlePlayAudio(audioUrl, 0.75)}>
          <Image src={SnailIcon} />
        </Center>
      </Flex>
      {!speechData?.result && (
        <Text fontSize={'24px'} mt={'40px'}>
          {sentence}
        </Text>
      )}

      {speechData?.result && (
        <Text fontSize={'24px'} mt={'40px'}>
          {speechData?.result?.map((word: any, index: number) => (
            <Text key={index} as={'span'}>
              {word.letters.map((char: any, index: any) => (
                <Text
                  key={index}
                  as={'span'}
                  color={getColorByScore(char.score * 100)}>
                  {char.letter}
                </Text>
              ))}{' '}
            </Text>
          ))}
        </Text>
      )}
      <Flex gap={'40px'} mt={'40px'} alignItems={'center'}>
        <Box w={'117px'} />
        <GlobalMic3
          isLoading={isLoading}
          handleStartRecording={handleStartRecording}
          handleRecordingComplete={handleRecordingComplete}
        />
        <GlobalButton
          h={'48px'}
          bg={CommonColors.primary}
          color={'white'}
          rightIcon={<ArrowRightIcon width={16} height={16} />}
          borderRadius={'99px'}
          fontWeight={600}
          onClick={() => setStep(5)}
          isDisabled={
            !(
              Math.floor(speechData?.total_score * 100) >= 60 ||
              recordingCount >= 2
            )
          }>
          Tiếp tục
        </GlobalButton>
      </Flex>
    </Flex>
  )
}

export default CheckPronunciation
